<template>
  <div class="choose-mars-box show-flex-box-c">
    <dl class="show-flex-box-c">
      <dt class="show-flex-box-c">
        <span>为什么选择德阳经开科创</span>
        <strong></strong>
      </dt>
      <dd class="choose-pic-box show-flex-box-r">
        <dl>
          <dt class="show-flex-box-r">
            <span class="show-flex-box-c" v-for="(firstItem,firstIndex) in firstImgList" :key="firstIndex">
              <img :src="firstItem.img" alt="德阳经开科创" draggable="false">
              <strong>{{firstItem.name}}</strong>
            </span>
          </dt>
          <dd class="show-flex-box-r">
            <span class="show-flex-box-c" v-for="(secondItem,secondIndex) in secondImgList" :key="secondIndex">
              <img :src="secondItem.img" alt="德阳经开科创" draggable="false">
              <strong>{{secondItem.name}}</strong>
            </span>
          </dd>
        </dl>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'choose_mars_box_cpn',
  data () {
    return {
      firstImgList: [
        {'img': require('../../assets/home/hexagon/hexagon_icon_1.png'),'name': '顺为高思领衔投资'},
        {'img': require('../../assets/home/hexagon/hexagon_icon_2.png'),'name': '北大实验室支撑'},
        {'img': require('../../assets/home/hexagon/hexagon_icon_3.png'),'name': '完善的课程体系'},
        {'img': require('../../assets/home/hexagon/hexagon_icon_4.png'),'name': '全国先进的物联网编程系统'},
      ],
      secondImgList: [
        {'img': require('../../assets/home/hexagon/hexagon_icon_5.png'),'name': '编程赛事支持'},
        {'img': require('../../assets/home/hexagon/hexagon_icon_6.png'),'name': '丰富的教研经验'},
        {'img': require('../../assets/home/hexagon/hexagon_icon_7.png'),'name': '食品级生产线安全有保障'}
      ]
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .choose-mars-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .choose-mars-box{
    position: relative;
    width: 100%;
    &>dl{
      width: 1200px;
      margin: 0 auto;
      &>dt{
        align-items: center;
        &>span{
          word-wrap: none;
          .choose-mars-font-style( 40px; bold; auto; #191D21 );
          padding-top: 66px;
        }
        &>strong{
          display: block;
          width: 130px;
          height: 5px;
          background: #FF7800;
          margin-top: 19px;
          margin-bottom: 55px;
        }
      }
      &>.choose-pic-box{
        width: 100%;
        padding-bottom: 30px;
        justify-content: center;
        &>dl{
          width: 1200px;
          &>dt{
            position: relative;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            &>span{
              align-items: center;
              justify-content: center;
              font-size: 0;
              line-height: 340px;
              text-align: center;
              width: 296px;
              height: 340px;
              background: url('../../assets/home/hexagon/hexagon_icon.png') no-repeat center center;
              background-size: 296px 340px;
              &>img{
                width: 88px;
                vertical-align: middle;
                margin-bottom: 37px;
              }
              &>strong{
                display: block;
                .choose-mars-font-style( 18px; 500; 18px; #2D2D2D );
              }
            }
          }
          &>dd{
            position: relative;
            bottom: 80px;
            padding-left: 150px;
            padding-right: 150px;
            justify-content: space-between;
            align-items: center;
            &>span{
              align-items: center;
              justify-content: center;
              font-size: 0;
              line-height: 340px;
              text-align: center;
              width: 296px;
              height: 340px;
              background: url('../../assets/home/hexagon/hexagon_icon.png') no-repeat center center;
              background-size: 296px 340px;
              &>img{
                width: 88px;
                vertical-align: middle;
                margin-bottom: 37px;
              }
              &>strong{
                display: block;
                .choose-mars-font-style( 18px; 500; 18px; #2D2D2D );
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/choose_mars_box_cpn.vue